<form
  [formGroup]="form"
  role="tax-calculator"
  class="py-3 block flex flex-auto flex-column justify-content-center align-items-center"
  style="z-index: 100000"
  (ngSubmit)="submit()"
>
  <div class="col-12">
    <div class="flex justify-content-between">
      <div class="col-3">
        <label for="quantity" class="pb-1 block font-bold">Quantity</label>
        <input pInputText inputmode="number" id="quantity" aria-describedby="quantity-help" formControlName="quantity" />
      </div>

      <div class="col-1 flex justify-content-center align-items-center text-center" style="align-self: anchor-center !important">
        <i class="pi pi-times font-bold pt-3"></i>
      </div>

      <div class="col-4">
        <label for="itemCost" class="pb-1 block font-bold">Selling Price (incl. of tax)</label>
        <p-inputGroup>
          <p-inputGroupAddon>{{ currency()?.code || currency()?.symbol }}</p-inputGroupAddon>
          <input pInputText inputmode="number" id="itemCost" aria-describedby="itemCost-help" formControlName="itemCost" />
        </p-inputGroup>
      </div>

      <div class="col-1 flex justify-content-center align-items-center text-center" style="align-self: anchor-center !important">
        <span style="font-size: 2rem" class="font-bold pt-3">=</span>
      </div>

      <div class="col-3">
        <div class="card total-amount">
          <small class="text-blue-500 pb-1">Total Amount</small>
          <p class="m-0 font-bold">
            {{ currency()?.code || currency()?.symbol }} {{ form.get('itemCost')?.getRawValue() * form.get('quantity')?.getRawValue() }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 mb-1 flex-shrink-0">
    <p-multiSelect
      [options]="taxOptions()"
      formControlName="taxes"
      optionLabel="name"
      optionValue="_id"
      placeholder="Select Applicable Taxes"
      display="chip"
      appendTo="body"
    >
      <ng-template let-tax pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ tax.name }}</div>
        </div>
      </ng-template>

      <ng-template pTemplate="footer">
        <div class="add-item col-12 text-white text-center cursor-pointer" (click)="openAddTaxComponent()">
          <span class="block"><i class="pi pi-plus pl-4"></i> Add new tax </span>
        </div>
      </ng-template>
    </p-multiSelect>
  </div>
</form>
